export default "__VITE_ASSET__C0WPZT5v__"